import React from 'react';
import styled from 'styled-components';

const CardContainer = styled.div`
  background: ${props => props.theme.colors.cardBg};
  border-radius: ${props => props.$radius || '8px'};
  border: 1px solid ${props => props.theme.colors.border};
  padding: ${props => props.$padding || '0.625rem'};
`;

const Title = styled.div`
  font-size: ${props => props.$size || '10px'};
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: 2px;
  text-transform: ${props => props.$uppercase ? 'uppercase' : 'none'};
  letter-spacing: ${props => props.$uppercase ? '0.3px' : 'normal'};
`;

const Value = styled.div`
  font-size: ${props => props.$size || '1.125rem'};
  font-weight: 700;
  color: ${props => props.theme.colors.textPrimary};
  line-height: 1.1;
`;

const Change = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;
  font-size: 10px;
  color: ${props => 
    props.$positive ? '#10b981' : 
    props.$negative ? '#ef4444' : 
    props.theme.colors.textSecondary};
`;

const Subtitle = styled.div`
  font-size: 10px;
  color: ${props => props.theme.colors.textSecondary};
  margin-top: 2px;
`;

/**
 * SummaryCard Component
 * 
 * A card for displaying a summary metric (used in reports)
 * 
 * @param {string} title - Card title (small text above value)
 * @param {string|number} value - Main value to display
 * @param {string} change - Change text (e.g., "+12.5% from last period")
 * @param {boolean} changePositive - If true, change is green
 * @param {boolean} changeNegative - If true, change is red
 * @param {string} subtitle - Additional text below value
 * @param {string} padding - Custom padding
 * @param {string} valueSize - Custom value font size
 * @param {boolean} uppercaseTitle - Uppercase the title
 * @param {string} className - Additional CSS class
 */
const SummaryCard = ({
  title,
  value,
  change,
  changePositive,
  changeNegative,
  subtitle,
  padding,
  valueSize,
  uppercaseTitle = true,
  className
}) => {
  return (
    <CardContainer $padding={padding} className={className}>
      {title && <Title $uppercase={uppercaseTitle}>{title}</Title>}
      <Value $size={valueSize}>{value}</Value>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {change && (
        <Change $positive={changePositive} $negative={changeNegative}>
          {change}
        </Change>
      )}
    </CardContainer>
  );
};

export default SummaryCard;
